import { render, staticRenderFns } from "./SelectDesign.vue?vue&type=template&id=8b2902e4&scoped=true"
import script from "./SelectDesign.vue?vue&type=script&lang=js"
export * from "./SelectDesign.vue?vue&type=script&lang=js"
import style0 from "./SelectDesign.vue?vue&type=style&index=0&id=8b2902e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2902e4",
  null
  
)

export default component.exports